import React, { useState, useEffect } from 'react';
import './Admin.css';

const BrandsManager = () => {
    const [brands, setBrands] = useState([]);
    const [settings, setSettings] = useState({
        title: 'Бренды',
        showTitle: true,
        speed: 20,
        pauseOnHover: true
    });
    const [loading, setLoading] = useState(true);
    const [draggedItem, setDraggedItem] = useState(null);
    const [message, setMessage] = useState('');
    const [uploading, setUploading] = useState(false);

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        setLoading(true);
        try {
            const [brandsRes, settingsRes] = await Promise.all([
                fetch('http://localhost:4000/api/content/brands?field=items'),
                fetch('http://localhost:4000/api/content/brands?field=settings')
            ]);

            const brandsData = await brandsRes.json();
            const settingsData = await settingsRes.json();

            let allBrands = brandsData.data || [];
            allBrands.sort((a, b) => (a.order || 0) - (b.order || 0));

            setBrands(allBrands);
            setSettings(settingsData.data || { title: 'Бренды', showTitle: true, speed: 20, pauseOnHover: true });
        } catch (error) {
            console.error('Ошибка загрузки:', error);
            setMessage('❌ Ошибка загрузки');
        } finally {
            setLoading(false);
        }
    };

    const saveBrands = async (brandsToSave) => {
        try {
            await fetch('http://localhost:4000/api/content/brands', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ field: 'items', data: brandsToSave })
            });
        } catch (error) {
            console.error('Ошибка сохранения:', error);
        }
    };

    const saveSettings = async () => {
        try {
            await fetch('http://localhost:4000/api/content/brands', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ field: 'settings', data: settings })
            });
            setMessage('✅ Настройки сохранены!');
            setTimeout(() => setMessage(''), 2000);
        } catch (error) {
            setMessage('❌ Ошибка сохранения');
        }
    };

    const addBrand = () => {
        const newBrand = {
            id: Date.now().toString(),
            type: 'text',
            name: 'Новый бренд',
            emoji: '⭐',
            visible: true,
            order: brands.length
        };
        const newBrands = [...brands, newBrand];
        setBrands(newBrands);
        saveBrands(newBrands);
        setMessage('✅ Бренд добавлен');
        setTimeout(() => setMessage(''), 2000);
    };

    const updateBrand = (id, field, value) => {
        const updatedBrands = brands.map(b =>
            b.id === id ? { ...b, [field]: value } : b
        );
        setBrands(updatedBrands);
        saveBrands(updatedBrands);
    };

    const deleteBrand = (id) => {
        if (!confirm('Удалить бренд?')) return;
        const filteredBrands = brands.filter(b => b.id !== id);
        const reorderedBrands = filteredBrands.map((b, idx) => ({ ...b, order: idx }));
        setBrands(reorderedBrands);
        saveBrands(reorderedBrands);
        setMessage('✅ Бренд удален');
        setTimeout(() => setMessage(''), 2000);
    };

    const toggleVisibility = (id) => {
        const updatedBrands = brands.map(b =>
            b.id === id ? { ...b, visible: !b.visible } : b
        );
        setBrands(updatedBrands);
        saveBrands(updatedBrands);
    };

    const handleImageUpload = async (brandId, file) => {
        if (!file) return;

        setUploading(true);
        const formData = new FormData();
        formData.append('brandImage', file);

        try {
            const response = await fetch('http://localhost:4000/api/upload/brand-image', {
                method: 'POST',
                body: formData
            });

            if (response.ok) {
                const data = await response.json();
                updateBrand(brandId, 'imageUrl', data.url);
                updateBrand(brandId, 'type', 'image');
                setMessage('✅ Логотип загружен');
            }
        } catch (error) {
            console.error('Ошибка загрузки:', error);
            setMessage('❌ Ошибка загрузки изображения');
        } finally {
            setUploading(false);
        }
    };

    const handleDragStart = (e, index) => {
        setDraggedItem(index);
        e.dataTransfer.effectAllowed = 'move';
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDrop = async (e, dropIndex) => {
        e.preventDefault();
        if (draggedItem === null) return;

        const newBrands = [...brands];
        const [draggedBrand] = newBrands.splice(draggedItem, 1);
        newBrands.splice(dropIndex, 0, draggedBrand);

        const reorderedBrands = newBrands.map((b, idx) => ({ ...b, order: idx }));
        setBrands(reorderedBrands);
        await saveBrands(reorderedBrands);
        setDraggedItem(null);
        setMessage('✅ Порядок изменен');
        setTimeout(() => setMessage(''), 2000);
    };

    if (loading) return <div className="loading-spinner">Загрузка брендов...</div>;

    const visibleBrands = brands.filter(b => b.visible);

    return (
        <div className="brands-manager">
            <h2>🏷️ Управление брендами</h2>

            {message && <div className="message success">{message}</div>}

            {/* Настройки */}
            <div className="settings-section">
                <h3>⚙️ Настройки блока</h3>
                <div className="settings-grid">
                    <div className="setting-item">
                        <label>Заголовок</label>
                        <input
                            type="text"
                            value={settings.title}
                            onChange={(e) => setSettings({...settings, title: e.target.value})}
                        />
                    </div>
                    <div className="setting-item checkbox">
                        <label>
                            <input
                                type="checkbox"
                                checked={settings.showTitle}
                                onChange={(e) => setSettings({...settings, showTitle: e.target.checked})}
                            />
                            Показывать заголовок
                        </label>
                    </div>
                    <div className="setting-item">
                        <label>Скорость анимации (сек)</label>
                        <input
                            type="number"
                            value={settings.speed}
                            onChange={(e) => setSettings({...settings, speed: Number(e.target.value)})}
                            min="5"
                            max="40"
                        />
                    </div>
                    <div className="setting-item checkbox">
                        <label>
                            <input
                                type="checkbox"
                                checked={settings.pauseOnHover}
                                onChange={(e) => setSettings({...settings, pauseOnHover: e.target.checked})}
                            />
                            Пауза при наведении
                        </label>
                    </div>
                </div>
                <button onClick={saveSettings} className="add-brand-btn">
                    💾 Сохранить настройки
                </button>
            </div>

            {/* Список брендов */}
            <div className="brands-list">
                <div className="list-header">
                    <h3>Список брендов (перетаскивайте для сортировки)</h3>
                    <button onClick={addBrand} className="add-brand-btn">+ Добавить бренд</button>
                </div>

                <div className="brands-grid">
                    {brands.map((brand, idx) => (
                        <div
                            key={brand.id}
                            className={`brand-item ${!brand.visible ? 'hidden' : ''} ${draggedItem === idx ? 'dragging' : ''}`}
                            draggable
                            onDragStart={(e) => handleDragStart(e, idx)}
                            onDragOver={handleDragOver}
                            onDrop={(e) => handleDrop(e, idx)}
                        >
                            <div className="drag-handle">⋮⋮</div>

                            <div className="brand-preview">
                                {brand.type === 'image' && brand.imageUrl ? (
                                    <img
                                        src={`http://localhost:4000${brand.imageUrl}`}
                                        alt={brand.name}
                                        className="brand-image"
                                    />
                                ) : (
                                    <div className="brand-text-preview">
                                        <span className="brand-emoji">{brand.emoji || '🏷️'}</span>
                                        <span className="brand-name">{brand.name}</span>
                                    </div>
                                )}
                            </div>

                            <div className="brand-controls">
                                <div className="brand-inputs">
                                    <select
                                        value={brand.type}
                                        onChange={(e) => updateBrand(brand.id, 'type', e.target.value)}
                                        className="type-select"
                                    >
                                        <option value="text">Текст</option>
                                        <option value="image">Изображение</option>
                                    </select>

                                    {brand.type === 'text' ? (
                                        <>
                                            <input
                                                type="text"
                                                value={brand.emoji || ''}
                                                onChange={(e) => updateBrand(brand.id, 'emoji', e.target.value)}
                                                placeholder="Эмодзи"
                                                className="emoji-input"
                                                maxLength="2"
                                            />
                                            <input
                                                type="text"
                                                value={brand.name}
                                                onChange={(e) => updateBrand(brand.id, 'name', e.target.value)}
                                                placeholder="Название бренда"
                                                className="name-input"
                                            />
                                        </>
                                    ) : (
                                        <div className="image-upload">
                                            <input
                                                type="file"
                                                accept="image/*"
                                                onChange={(e) => handleImageUpload(brand.id, e.target.files[0])}
                                                style={{ display: 'none' }}
                                                id={`upload-${brand.id}`}
                                            />
                                            <label htmlFor={`upload-${brand.id}`} className="upload-image-btn">
                                                {brand.imageUrl ? '🔄 Заменить' : '📸 Загрузить логотип'}
                                            </label>
                                            {brand.imageUrl && (
                                                <button
                                                    onClick={() => updateBrand(brand.id, 'imageUrl', null)}
                                                    className="remove-image-btn"
                                                >
                                                    ✕
                                                </button>
                                            )}
                                        </div>
                                    )}
                                </div>

                                <div className="brand-actions">
                                    <button
                                        onClick={() => toggleVisibility(brand.id)}
                                        className="visibility-btn"
                                        title={brand.visible ? 'Скрыть' : 'Показать'}
                                    >
                                        {brand.visible ? '👁️' : '👁️‍🗨️'}
                                    </button>
                                    <button
                                        onClick={() => deleteBrand(brand.id)}
                                        className="delete-btn"
                                        title="Удалить"
                                    >
                                        🗑️
                                    </button>
                                </div>
                            </div>

                            <div className="brand-order">{idx + 1}</div>
                        </div>
                    ))}
                </div>

                {brands.length === 0 && (
                    <div className="empty-state">Нет брендов. Нажмите "+ Добавить бренд"</div>
                )}
            </div>

            {/* Предпросмотр */}
            <div className="preview-section">
                <h3>🖼️ Предпросмотр на сайте</h3>
                <div className="site-preview">
                    {settings.showTitle && <h4>{settings.title}</h4>}
                    <div className="preview-marquee">
                        {visibleBrands.map((brand, idx) => (
                            <div key={idx} className="preview-brand-item">
                                {brand.type === 'image' && brand.imageUrl ? (
                                    <img
                                        src={`http://localhost:4000${brand.imageUrl}`}
                                        alt={brand.name}
                                        className="preview-brand-image"
                                    />
                                ) : (
                                    <>
                                        <span className="preview-brand-emoji">{brand.emoji || '🏷️'}</span>
                                        <span className="preview-brand-name">{brand.name}</span>
                                    </>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BrandsManager;